module.exports = __webpack_public_path__ + "assets/img/tx102z_1.ca4b59fb.jpg";